import { Component, Inject, OnInit, TemplateRef, ViewChild, } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogComponent } from '../../components/dialog/dialog.component';

import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, combineLatest, interval, NEVER, Observable, of, ReplaySubject } from 'rxjs';
import { catchError, map, startWith, switchMap, filter } from 'rxjs/operators';



import { GraphQlAppendWheres } from '../../operators/graphql/append-wheres/graphql-append-wheres.operator';
import { GraphQlQueryExecutor } from '../../operators/graphql/query-executor/graphql-query-executor.operator';
import { GraphQlQueryResultToNgxMulti } from '../../operators/graphql/query-result-to-ngx-multi/graphql-query-result-to-ngx-multi.operator';


import { NgxMultiValuePercentage } from '../../operators/ngx/multi-value-percentage/ngx-multi-value-percentage.operator';
import { NgxMultiToSingle } from '../../operators/ngx/multi-to-single/ngx-multi-to-single.operator';

import { EveInternal } from '../../operators/eve/interval/eve-interval.operator';
import { GraphQlQueryResultToNgxSingle } from '../../operators/graphql/query-result-to-ngx-single/graphql-query-result-to-ngx-single.operator';

import { GraphQLComparision } from '../../enums/GraphQLComparision.enum';
import { GraphQLFilter, GraphQLGroupBy, GraphQlQuery, IGraphQlService } from '../../services/GraphQl/IGraphQL.service';
import { Single } from '../../interfaces/single.interface';
import { IVisibilityStateService } from '../../services/VisibilityState/IVisibilityState.service';



export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}

@Component({
  selector: 'missed-calls-report',
  templateUrl: './missed-calls-report.component.html',
  styleUrls: ['./missed-calls-report.component.css']
})
export class MissedCallsReportComponent implements OnInit {


  @ViewChild('EveCdrsDialogTemplate') eveCdrsDialogTemplate: TemplateRef<any>;
  @ViewChild('TelepoCdrsDialogTemplate') telepoCdrsDialogTemplate: TemplateRef<any>;

  document = document;
  scale: number = 1.5;
  
  

  minStartDate: Observable<Date> = interval(60000).pipe(
    startWith(null),
    map(() => {
      const minStartDate = new Date();
      minStartDate.setMonth(minStartDate.getMonth() - 3);
      if (minStartDate > new Date('2022-07-19')) {
        return minStartDate;
      }
      else {
        return new Date('2022-07-19');
      }
    })
  );


  menuOpened: boolean = true;

  
  startDate: ReplaySubject<Date> = new ReplaySubject<Date>();
  endDate: ReplaySubject<Date> = new ReplaySubject<Date>();
  //startDate: BehaviorSubject<String> = new BehaviorSubject<String>("now/M");
  //endDate: BehaviorSubject<String> = new BehaviorSubject<String>("now/M+8d");

  workingHoursStartTime: BehaviorSubject<string> = new BehaviorSubject<string>("09:00");
  workingHoursEndTime: BehaviorSubject<string> = new BehaviorSubject<string>("17:00");

  

  company: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  wheres: Observable<GraphQLFilter[]> = combineLatest(
    this.startDate.pipe(
      filter(startDate => startDate != null),
      map(d => { d?.setHours(0); d?.setMinutes(0); d?.setSeconds(0); d?.setMilliseconds(0); return d; })
    ),
    this.endDate.pipe(
      filter(endDate => endDate != null),
      map(d => { d?.setHours(23); d?.setMinutes(59); d?.setSeconds(59); d?.setMilliseconds(999); return d; })
    ),
    this.company,
    this.workingHoursStartTime,
    this.workingHoursEndTime
  )
    .pipe(
      map(([startDate, endDate, company, workingHoursStartTime, workingHoursEndTime]) => {

        const filters: GraphQLFilter[]  = [
          {
            path: "startTime",
            comparison: GraphQLComparision.GREATER_THAN_OR_EQUAL,
            value: startDate
          } as GraphQLFilter,
          {
            path: "startTime",
            comparison: GraphQLComparision.LESS_THAN_OR_EQUAL,
            value: endDate
          } as GraphQLFilter,
          {
            path: "companyOrganisationNode",
            comparison: GraphQLComparision.EQUAL,
            value: company?.organisationNode ?? null
          } as GraphQLFilter,
        ];

        const startDur = this.toIsoHmDuration(workingHoursStartTime);
        if (startDur) {
          filters.push({
            path: 'startTime_Time',
            comparison: GraphQLComparision.GREATER_THAN_OR_EQUAL,
            value: startDur
          });
        }

        const endDur = this.toIsoHmDuration(workingHoursEndTime);
        if (endDur) {
          filters.push({
            path: 'startTime_Time',
            comparison: GraphQLComparision.LESS_THAN_OR_EQUAL,
            value: endDur
          });
        }

         
        return filters;
      })
  );


private toIsoHmDuration(value?: string | null): string | null {
  if (!value) return null;
  const m = /^\s*(\d{1,2})(?::(\d{1,2}))?\s*$/.exec(value);
  if (!m) return null;

  const h = parseInt(m[1], 10);
  const min = m[2] !== undefined ? parseInt(m[2], 10) : 0;

  if (Number.isNaN(h) || Number.isNaN(min)) return null;

  let out = 'PT';
  if (h) out += `${h}H`;
  if (min) out += `${min}M`;
  if (out === 'PT') out = 'PT0S'; // e.g. "00:00"
  return out;
}
  
  
  answerCallsPercentageResults: Observable<Single[]> = of<GraphQlQuery>({
    dataset: "eveCdrsPage",
    selects: [
      {
        field: "count",
        arguments: null
      },
      {
        field: "eveCdrAnsweredType",
        arguments: null
      }
    ],
    wheres: [
      { path: 'eveCdrCallType', comparison: GraphQLComparision.EQUAL, value: "INBOUND" },
      { path: "eveCdrAnsweredType", comparison: GraphQLComparision.NOT_EQUAL, value: null },
    ],
    groupBys: [{ path: "eveCdrAnsweredType" } as GraphQLGroupBy],
    page: 0,
    pageSize: -1
  }).pipe(
    GraphQlAppendWheres(this.wheres),
    switchMap(query => of(query)
      .pipe(
        GraphQlQueryExecutor(of(this.graphQlService)),
        EveInternal(5000, this.visibilityStateService.VisibilityState()),
        GraphQlQueryResultToNgxMulti(),
        NgxMultiValuePercentage(),
        NgxMultiToSingle(),
        map(singles => {
          if (singles.length == 0) return singles;

          const eveUser = singles.find(s => s.name == "EVE_USER");
          return eveUser != null ? [eveUser] : [{
            name: "EVE_USER",
            value: 0,
            query: query
          }];
        })

      )
    )
  )
  


  



  expandedElement: Element;


  constructor(
    @Inject("BASE_REPORTING") public reportingUrl: string,
    public dialog: MatDialog,
    private router: Router,
    public graphQlService: IGraphQlService,
    public visibilityStateService: IVisibilityStateService) {
  }

 



 


  ngOnInit() {
    const now = new Date();
    const midnightToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23,59,59);
    const startDate = new Date(midnightToday.getTime());
    startDate.setDate(startDate.getDate() - 30);

    this.startDate.next(new Date(startDate));
    this.endDate.next(midnightToday);

    
  }



 

  onExpand(template) {
    this.dialog.open(DialogComponent, {
      height: '75%',
      width: '75%',
      data: {
        header: "Calls",
        content: template
      },
      autoFocus: false
    });
  }

  cradleToGraveNav() {
    //alert("hello!");
    this.router.navigate(['/', 'CradleToGravePage']);
  }

  
  

  missedCallsByUserRating: Observable<Single[]> = of<GraphQlQuery>({
    dataset: "telepoCdrsPage",
    selects: [
      {
        field: "count"
      },
      {
        field: "telepoCdrAnsweredType",
      },
      {
        field: "targetOwnerTypeId",
      },
      {
        field: "targetOwnerId",
      },
      {
        field: "targetOwner",
      },
    ],
    wheres: [
      { path: "telepoCdrAnsweredType", comparison: GraphQLComparision.NOT_EQUAL, value: null },
      { path: "telepoCdrAnsweredType", comparison: GraphQLComparision.NOT_EQUAL, value: "EVE_USER" },
      { path: "targetOwnerTypeId", comparison: GraphQLComparision.EQUAL, value: 0 },
      { path: "type", comparison: GraphQLComparision.EQUAL, value: 2 },
    ],
    groupBys: [
      { path: "targetOwnerTypeId" },
      { path: "targetOwnerId" }
    ],
    orderBy: [{ path: "count", descending:true }],
    page: 0,
    pageSize: 10
  }).pipe(
    GraphQlAppendWheres(this.wheres),
    GraphQlQueryExecutor(of(this.graphQlService)),
    EveInternal(5000, this.visibilityStateService.VisibilityState()),
    GraphQlQueryResultToNgxSingle("${this.targetOwner}",i => i.count)
  );

  public onEveCdrGraphSelect(event) {
    this.dialog.open(DialogComponent, {
      height: '75%',
      width: '75%',
      autoFocus: false,
      data: {
        header: "Calls",
        content: this.eveCdrsDialogTemplate,
        query: {
          dataset: event.query.dataset,
          selects: [
            {
              field: "eveCdrSourceId"
            },
            {
              field: "callId"
            },
            {
              field: "initialCallId"
            },
            {
              field: "eveCdrCallType"
            },
            {
              field: "startTime"
            },
            {
              field: "sourcePhoneNumber"
            },
            {
              field: "sourceOwner"
            },
            {
              field: "sourceOwnerTypeId"
            },
            {
              field: "sourceOwner"
            },
            {
              field: "sourceOwnerId"
            },
            {
              field: "targetPhoneNumber"
            },
            {
              field: "targetOwner"
            },
            {
              field: "targetOwnerTypeId"
            },
            {
              field: "targetOwnerId"
            },
            {
              field: "duration"
            }
          ],
          wheres: event.query.wheres.concat(event.wheres),
          orderBy: [{ path: "startTime", descending: true }]
        }
      },
    });
  }


  public onAnsweredPerformanceSelect(event) {
    this.onEveCdrGraphSelect({
      query: event.query,
      wheres: [{
        path: "eveCdrAnsweredType", comparison: GraphQLComparision.NOT_EQUAL, value: "EVE_USER"
      }]
    })
    
  }

  public onTelepoCdrGraphSelect(event) {
    this.dialog.open(DialogComponent, {
      height: '75%',
      width: '75%',
      autoFocus: false,
      data: {
        header: "Calls",
        content: this.telepoCdrsDialogTemplate,
        query: {
          dataset: event.query.dataset,
          selects: [
            {
              field: "initialCallId"
            },
            {
              field: "startTime"
            },
            {
              field: "sourcePhoneNumber"
            },
            {
              field: "sourceOwner"
            },
            {
              field: "sourceOwnerTypeId"
            },
            {
              field: "sourceOwner"
            },
            {
              field: "sourceOwnerId"
            },
            {
              field: "targetPhoneNumber"
            },
            {
              field: "targetOwner"
            },
            {
              field: "targetOwnerTypeId"
            },
            {
              field: "targetOwnerId"
            },
            {
              field: "duration"
            }
          ],
          wheres: event.query.wheres.concat(event.wheres),
          orderBy: [{ path: "startTime", descending: true }]
        }
      },
    });
  }
}





export interface AutoCompleteOption {
  name: string,
  value: any
}



